import React, {useEffect, useMemo, useState} from 'react';

import './styles.scss';
import AppFooter from '../app-footer';
import {Column, Row} from '../layout';
import AppNavMenu from '../app-nav-menu';
import * as fonts from '../../util/fonts';
import AppUserLogout from '../app-userlogout/AppUserLogout';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {functionalitiesAliasMap, strings} from '../../util/strings';
import {createGUID} from '../../util/utility';
import Banner from '../../containers/homepage/banners/Banner';
import {get} from '../../api/api';
import NewAppHeader from '../headers/app-header/NewAppHeader';
import moment from 'moment';
import AppLanguageSelector from '../app-language-selector/AppLanguageSelector';
import {useRedirectUrl} from '../../contexts/RedirectUrlContext';
import {uriGetCampaigns} from '../../api/endpoints';

interface AppWrapperProps {
  children: any;
  user: any;
  labels: typeof strings.pt.menu;
  selectedBu: any;
  languageStrings: any;
  busStyles: any;
  updateMenu?: boolean;
}

function AppWrapper({
  children,
  user,
  labels,
  selectedBu,
  languageStrings,
  busStyles,
  updateMenu = false,
}: AppWrapperProps) {
  const [items, setItems] = useState<Array<any>>([]);
  const [appNavMenuId, setAppNavMenuId] = useState<any>();
  const [campaigns, setCampaigns]: any = useState();
  const [bannersEmpty, setBannersEmpty] = useState<boolean>(false);
  const [hideBanner, setHideBanner] = useState(false);
  const [showLanguageSelector, setShowLanguageSelector] = useState(false);
  const [updateImages, setUpdateImages] = useState(0);
  const [inHomePage, setInHomePage] = useState(false);
  const {setUrl} = useRedirectUrl();

  const getAllItems = () => {
    let arrayItems = [
      {
        label: labels?.menu_start_web,
        funct: functionalitiesAliasMap.menuStart,
        selector: [],
        url: '/inicio',
      },
      {
        label: labels?.menu_insurance_web,
        funct: functionalitiesAliasMap.menuInsurance,
        selector: [],
        url: '',
        subItems: [
          {
            label: labels?.menu_start_subitem_utilization,
            funct: functionalitiesAliasMap.utilization,
            selector: functionalitiesAliasMap.utilization,
            url: '/historico-utilizacao',
          },
          {
            label: labels?.menu_start_subitem_myData,
            funct: functionalitiesAliasMap.myData,
            selector: functionalitiesAliasMap.myData,
            url: '/meus-dados',
          },
          {
            label: labels?.menu_start_subitem_coverages,
            funct: functionalitiesAliasMap.coverages,
            selector: functionalitiesAliasMap.coverages,
            url: '/minhas-coberturas',
          },
          {
            label: labels?.menu_start_subitem_services,
            funct: functionalitiesAliasMap.services,
            selector: functionalitiesAliasMap.services,
            url: '/meus-servicos',
          },
          {
            label: labels?.menu_start_subitem_irs,
            funct: functionalitiesAliasMap.irs,
            selector: functionalitiesAliasMap.irs,
            url: '/declaracao-irs',
          },
        ],
      },
      {
        label: labels?.menu_medicalNetwork_web,
        funct: functionalitiesAliasMap.menuNetwork,
        selector: [],
        url: '/network',
      },
      {
        label: labels?.menu_requests_web,
        funct: functionalitiesAliasMap.menuRequests,
        selector: [],
        url: '',
        subItems: [
          {
            label: labels?.menu_start_subitem_refund,
            funct: functionalitiesAliasMap.refund,
            selector: functionalitiesAliasMap.refund,
            url: '/historico-reembolsos',
          },
          {
            label: labels?.menu_start_subitem_preAuthorizations,
            funct: functionalitiesAliasMap.authorization,
            selector: functionalitiesAliasMap.authorization,
            url: '/pre-autorizacoes',
          },
        ],
      },
      // {
      //   label: 'AdvanceCare+',
      //   selector: 'adv-plus',
      //   url: '/adv-plus',
      // },
    ];

    arrayItems = getAllUrls(arrayItems);
    setItems(arrayItems);
  };

  const getAllUrls = (arrayItems: Array<any>) => {
    arrayItems?.map((item) => {
      if (item.selector?.length < 1) {
        let arrayUrls: any = [];
        if (item.url != '') {
          arrayUrls = [item.url];
        } else {
          item.subItems?.map((subItem: any) => {
            arrayUrls = [...arrayUrls, subItem.url];
          });
        }
        item.selector = arrayUrls;
      }
    });
    return arrayItems;
  };

  const getBanners = async () => {
    let currentDate = moment();
    try {
      return await get(uriGetCampaigns(selectedBu.buId)).then(
        (campaignsElem: any) => {
          const campaigns = campaignsElem?.data?.items;
          const activeCampaigns =
            campaigns?.filter((r: any) => r.status === 'ACTIVE') || [];
          const aux: any[] = [];
          if (campaigns !== undefined) {
            activeCampaigns.forEach((campaign: any) => {
              const isInactiveForCurrentBu = campaign.campaignInactiveBUS.some(
                (buAlias: string) => buAlias === selectedBu.buId
              );
              if (
                !isInactiveForCurrentBu &&
                moment(campaign.startDate, 'DD-MM-YYYY').isSameOrBefore(
                  currentDate,
                  'day'
                ) &&
                moment(campaign.endDate, 'DD-MM-YYYY').isSameOrAfter(
                  currentDate,
                  'day'
                )
              ) {
                aux.push(campaign);
              }
            });
          }
          campaigns.sort((a: {endDate: number}, b: {endDate: number}) => {
            if (a.endDate > b.endDate) {
              return 1;
            }
            if (a.endDate < b.endDate) {
              return -1;
            }
            return 0;
          });
          setBannersEmpty(false);
          setCampaigns(campaigns?.slice(0, 5));
          setHideBanner(campaigns.length === 0 || aux.length === 0);
        }
      );
    } catch {
      setBannersEmpty(true);
    }
  };

  // everytime the labels change, the items change,
  // and therefore,
  // the AppNavMenu key must change to force rerender
  useEffect(() => {
    setInHomePage(window.location.pathname === '/inicio');
  }, [window.location.pathname]);

  useEffect(() => {
    getAllItems();
    setAppNavMenuId(createGUID());
  }, [labels, updateMenu]);

  useEffect(() => {
    try {
      const buStyles = busStyles?.find((el: any) => el.buId == selectedBu.buId);
      setUrl(buStyles?.urlLogout || null);
    } catch (err) {
      console.log('err', err);
    }
  }, [busStyles, selectedBu.buId]);

  useMemo(() => {
    selectedBu.buId && setUpdateImages(updateImages + 1);
  }, [selectedBu.buId]);

  useEffect(() => {
    window.location.pathname === '/inicio' && getBanners();
  }, [selectedBu.memId, window.location.pathname]);

  return (
    <Column className="app-wrapper-main-column">
      <NewAppHeader
        hideBanner={hideBanner}
        updateImages={updateImages}
        inHomePage={inHomePage}
      />

      {window.location.pathname === '/inicio' && !bannersEmpty && (
        <Banner campaigns={campaigns} enableBanner={!hideBanner} />
      )}
      <Column
        className={
          bannersEmpty
            ? 'app-wrapper-container-no-banners'
            : 'app-wrapper-container'
        }
        style={{...fonts.M}}>
        <Row className="app-wrapper-row">
          {user.state === 'CLIENT' && (
            <AppNavMenu key={appNavMenuId} items={items} />
          )}
          <AppUserLogout setShowLanguageSelector={setShowLanguageSelector} />
        </Row>
        {/* Add mode selection component here */}
      </Column>
      {children}
      <div className="app-wrapper-footer-wrapper">
        <AppFooter updateImages={updateImages} />
      </div>
      <AppLanguageSelector
        show={showLanguageSelector}
        setShow={setShowLanguageSelector}
      />
    </Column>
  );
}

const mapStateToProps = ({user, strings, selectedBu, busStyles}: any) => ({
  user: user.value,
  labels: strings.value.pt.menu,
  languageStrings: strings.value.pt.register,
  selectedBu: selectedBu.value,
  busStyles: busStyles.value,
});

export default compose(connect(mapStateToProps)(AppWrapper));
